'use strict';

/**
 *
 * @name: postGroup
 *
 */

import DirectiveTemplate from './nn-plain-text.directive.html';
import './nn-plain-text.directive.scss';

function PlainText($sce, $compile) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /*
       *
       * @CONFIG
       *
       */

      scope.item = scope.content();
      scope.isCollapsed = true;
      scope.hideLoadMoreButton = false;

      /*
       *
       * @PRIVATE
       *
       */

      function _init(){

        var content = scope.item.jsonData.plainText;
        var containsBrightcoveVideo = content.indexOf('data-video-id') > -1;
        var containsLoadMore = content.indexOf('nowness-load-more-marker') > -1;

        if(containsBrightcoveVideo){
          content = content.replace(new RegExp('data-video-id', 'g'), 'brightcove-new data-video-id');
        }

        if(containsLoadMore){

          var contentSplitted = content.split('<div class="nowness-addon noeditable" contenteditable="false"><div class="nowness-load-more-marker"></div></div>');
          var button =  '<div class="nn-plain-text__btn-wrapper" data-nn-collapse="{{ hideLoadMoreButton }}"><a href="#" class="nn-base-button" data-ng-click="toggleCollapse()">{{ ::\'LOAD_MORE\' | translate }}</a></div>';
          var visibleContent = contentSplitted[0];
          var hiddenContent = contentSplitted[1];

          content = visibleContent + button + '<div data-nn-collapse="{{ isCollapsed }}">' + hiddenContent + '</div>';
        }

        angular.element(element).find('#js-content').html(content);
        $compile(element.contents())(scope);
      }

      /*
       *
       * @PUBLIC
       *
       */

       scope.toggleCollapse = function(){
        scope.isCollapsed = !scope.isCollapsed;
        if(!scope.isCollapsed){
          scope.hideLoadMoreButton = true;
        }
       };

      /*
       *
       * @INIT
       *
       */

       _init();
    }
  };
}

export default PlainText;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-plain-text/nn-plain-text.directive.js